import { Injectable } from "@angular/core";

import { Observable} from "rxjs";

import { ApiRequestDispatcherService } from "../../../../shared-library/services/api/api-request-dispatcher.service";
import { BaseSearchResultsModel } from "../../models/base-search-results.model";
import { SearchParametersModel } from "../models/search-parameters.model";
import {ContentItemModel} from "../models/content-search.model";
import {ApiResponseDispatcherService} from "../../../../shared-library/services/api/api-response-dispatcher.service";
import {ExecutionResultModel} from "../../../../shared-library/models/api/execution-result.model";
import {SearchFilterMetadataModel} from "../../models/search-filter-metadata.model";
import {ContentSearchFilterMetadataModel} from "../models/content-search-filter-metadata.model";

@Injectable({
    providedIn: "root"
})
export class ContentSearchService {
    private readonly API_GET_LIST_URL = `//${window.location.hostname}/api/pcg-content-search/examine/get-search-results`;

    public constructor(
        private _requestDispatcher: ApiRequestDispatcherService,
        private _responseDispatcher: ApiResponseDispatcherService
    ) {
    }

    public getSearchResults(searchParams: SearchParametersModel): Observable<BaseSearchResultsModel<ContentItemModel>> {
        const response$ = this._requestDispatcher.post<ExecutionResultModel<BaseSearchResultsModel<ContentItemModel>>>(this.API_GET_LIST_URL, searchParams);
        return this._responseDispatcher.unwrap(response$);
    }

    public getSearchFilters(): Observable<Array<ContentSearchFilterMetadataModel>> {
        const response$ = this._requestDispatcher.get<ExecutionResultModel<Array<ContentSearchFilterMetadataModel>>>("/api/pcg-content-search/examine/get-search-filters");
        return this._responseDispatcher.unwrap(response$);
    }

    public getTemplateMetadata(templateId: string): Observable<Array<SearchFilterMetadataModel>> {
        return this._requestDispatcher.get<Array<SearchFilterMetadataModel>>("/api/s4s-advanced-search/directory-search/get-search-filters/" + templateId);
    }
}
